import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
import { UserStatusSchema } from "@inspire/data/schemas/user/profile/status";
import { LyceenProfileSchema } from "@inspire/data/schemas/user/profile/lyceen";
import { EclaireurProfileSchema } from "@inspire/data/schemas/user/profile/eclaireur";
import { PedagogieProfileSchema } from "@inspire/data/schemas/user/profile/pedagogie";
import { ExploreSchema } from "@inspire/data/schemas/user/profile/explore";
import { AdminProfileSchema } from "@inspire/data/schemas/user/profile/admin";
import { ProfProfileSchema } from "@inspire/data/schemas/user/profile/prof";
import { PartnershipSchema } from "@inspire/data/schemas/user/profile/partnership";
import { StaticHelpers } from "@inspire/data/helpers/static";
import { FrenchRegions } from "@inspire/data/static/regions";
var profileRoleField = {
    type: String,
    allowedValues: [
        "lyceen",
        "eclaireur",
        "admin",
        "worker",
        "pedagogie",
        "sso-registered"
    ]
};
export var nameRegex = /^[a-zA-ZàâäéèêëîïôöùûüçÀÂÄÉÈÊËÎÏÔÖÙÛÜÇ'\s-]{2,50}$/;
export var UserProfileSchema = new SimpleSchema({
    role: profileRoleField,
    firstName: {
        type: String,
        optional: true
    },
    lastName: {
        type: String,
        optional: true
    },
    notifications: {
        type: Object,
        optional: true
    },
    "notifications.media": {
        type: Object,
        optional: true
    },
    "notifications.media.onsite": {
        type: Boolean,
        optional: true
    },
    "notifications.media.email": {
        type: Boolean,
        optional: true
    },
    "notifications.media.facebook": {
        type: Boolean,
        optional: true
    },
    "notifications.media.sms": {
        type: Boolean,
        optional: true
    },
    mineur: {
        type: Boolean,
        optional: true
    },
    conditionsGenerales: {
        type: Boolean,
        optional: true,
        autoform: {
            type: "boolean-checkbox"
        }
    },
    newsletter: {
        type: Boolean,
        optional: true,
        autoform: {
            type: "boolean-checkbox"
        }
    },
    update_newsletter: {
        type: Date,
        optional: true
    },
    newsletterAnnabac: {
        type: Boolean,
        optional: true
    },
    referredBy: {
        type: String,
        optional: true
    },
    referrals: {
        type: Array,
        optional: true
    },
    "referrals.$": {
        type: String,
        optional: true
    },
    welcomeEmailSent: {
        type: Boolean,
        optional: true
    },
    algoResultsRating: {
        type: Number,
        optional: true,
        allowedValues: [
            -2,
            2
        ]
    },
    codePostal: {
        type: String,
        optional: true,
        label: "Code postal",
        custom: function custom() {
            var frenchCodePostal = new RegExp(/^[0-9][0-9AB][0-9]{3}$/gi);
            if (this.value && !frenchCodePostal.test(this.value)) {
                return "invalidZipCode";
            }
        }
    },
    region: {
        type: String,
        allowedValues: FrenchRegions,
        optional: true,
        autoValue: function autoValue() {
            var codePostal = this.field("profile.codePostal").value;
            if (codePostal && StaticHelpers.getRegionFromPostalCode(codePostal)) {
                return StaticHelpers.getRegionFromPostalCode(codePostal);
            }
        }
    },
    picture: {
        type: String,
        optional: true
    },
    createdAt: {
        type: Date,
        optional: true
    }
})// user status
.extend(UserStatusSchema)// lyceen profile
.extend(LyceenProfileSchema)// lyceen profile
.extend(EclaireurProfileSchema)// questionnaire explore
.extend(ExploreSchema)// admin specific profile fields
.extend(AdminProfileSchema)// pedagogie specific fields
.extend(PedagogieProfileSchema)// profs Bac Pro profile fields
.extend(ProfProfileSchema).extend(PartnershipSchema);
